<template>
    <v-select
        :options="selectOptions"
        :clearable="false"
        :searchable="false"
        :model-value="selected"
        class="rounded-sm border border-black h-12 px-2 flex items-center justify-end bg-white font-sans style-chooser"
        @update:modelValue="onSelected"
    />
</template>

<script>
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {
            vSelect,
        },

        emits: ['input'],

        computed: {
            selected() {
                return this.selectOptions.find((x) => x.selected)?.label;
            },
        },

        props: {
            selectOptions: {
                type: Array,
                required: true,
            },
        },

        methods: {
            onSelected(v) {
                this.$emit('input', v);
            },
        },
    };
</script>

<style lang="scss">
    // :P

    #cz3 {
        .style-chooser .vs__open-indicator {
            @apply fill-black;
        }

        .style-chooser .vs__dropdown-toggle {
            @apply p-0 w-full items-center;
        }

        .style-chooser .vs__selected {
            @apply m-0 p-0 text-base font-sans;
        }

        .style-chooser .vs__dropdown-menu {
            @apply top-auto rounded-t rounded-b-none;
            bottom: calc(100% + 1px);
        }

        .style-chooser .vs__dropdown-option {
            @apply px-2 py-3 text-base font-sans;
        }

        .style-chooser .vs__dropdown-option--highlight {
            @apply bg-ink;
        }
    }
</style>
